import ReactCropper from "react-cropper";
import "cropperjs/dist/cropper.css";

import { useContext } from "react";

import { useMediaQuery } from "@chakra-ui/react";

import { CropperContext, CropperContextType } from "../context";

function Editor() {
  const {
    cropperRef,
    setStatus,
    isCropActive,
    setIsCropActive,
    imageToBeCropped
  } = useContext(CropperContext) as CropperContextType;
  const [isDesktop] = useMediaQuery(["(min-width: 768px)"]);

  return (
    <ReactCropper
      style={{ width: "100%", height: isDesktop ? 400 : "100%" }}
      restore={false}
      src={imageToBeCropped}
      ref={cropperRef}
      viewMode={0}
      dragMode="crop"
      guides={false}
      autoCrop={false}
      autoCropArea={1}
      background={false}
      zoomOnWheel={false}
      zoomOnTouch={false}
      initialAspectRatio={16 / 9}
      toggleDragModeOnDblclick={false}
      onLoad={() => setStatus("enabled")}
      cropstart={() => setIsCropActive(!isCropActive)}
      zoom={function (e: any) {
        let initialRatio =
          e.target?.cropper?.initialCanvasData.width /
          e.target?.cropper?.initialCanvasData.naturalWidth;
        if (e.detail.ratio < initialRatio) {
          // prevent zoom-out if the ratio (canvasWidth/naturalWidth) is less than the initialRatio
          e.preventDefault();
        }
      }}
    />
  );
}

export { Editor };
